import { render, staticRenderFns } from "./clients_canceled.vue?vue&type=template&id=2f4de5f7"
import script from "./clients_canceled.vue?vue&type=script&lang=js"
export * from "./clients_canceled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports